import { lazy } from 'react'

export const MarkdownComp = lazy(() => import('./MarkdownLazy'))
